import { AxiosInstance } from 'axios';
import MockAdapter from 'axios-mock-adapter';
import configs from 'configs';

import postLogin from './mocks/postLogin.json';
import getUserProfile from './mocks/getUserProfile.json';
import getAlbums from './mocks/albums.json';
import getImage from './mocks/image.json';
import getHistoryReceiving from './mocks/getHistoryReceving.json';
import getSiteAgent from './mocks/getSiteAgent.json';
import getHistorySending from './mocks/getHistorySending.json';
import getSiteDirectorSites from './mocks/userSites.json';
import getWorkerStatus from './mocks/getWorkerStatus.json';
import getWorkRisk from './mocks/getWorkRisk.json';
import getCheckSlingTool from './mocks/getCheckSlingTool.json';
import getListTestScaffold from './mocks/getListTestScaffold.json';
import getSafetyInstructions from './mocks/getSafetyInstructions.json';
import getWorkerShift from './mocks/getWorkerShift.json';
import getWorkerShiftBo0101 from './mocks/getWorkerShiftBo0101.json';
import getWorkerShiftTable from './mocks/getWorkerShiftTable.json';
import getDataGanttSupport from './mocks/getDataGanttSupport.json';
import getTableForm from './mocks/getTableForm.json';
import branchs from './mocks/branchs.json';

export default function mockAdapter(instance: AxiosInstance) {
  if (!configs.USE_MOCK_API) {
    return;
  }

  const mock = new MockAdapter(instance, { delayResponse: 1500 });

  mock.onPost('/login').replyOnce(400).onPost('/login').reply(200, postLogin);
  mock.onGet('/sites/images').reply(200, getAlbums);
  mock.onGet('/image').reply(200, getImage);
  mock.onGet('/profile').reply(200, getUserProfile);
  mock.onGet('/shop/sites').reply(200, getHistoryReceiving);
  mock.onGet('/site/agent').reply(200, getSiteAgent);
  mock.onGet('/shop/sites/sending').reply(200, getHistorySending);
  mock.onGet('/user/sites').reply(200, getSiteDirectorSites);
  mock.onGet('/worker_status').reply(200, getWorkerStatus);
  mock.onGet('/work_risk').reply(200, getWorkRisk);
  mock.onGet('/shop/check_sling_tool').reply(200, getCheckSlingTool);
  mock.onGet('/worker/list_test_scaffold').reply(200, getListTestScaffold);
  mock.onGet('/worker/safety_nstructions').reply(200, getSafetyInstructions);
  mock.onGet('/user/schedules').reply(200, getWorkerShift);
  mock.onGet('/user/schedules/bo-01-01').reply(200, getWorkerShiftBo0101);
  mock.onGet('/worker/worker_shift_table').reply(200, getWorkerShiftTable);
  mock.onGet('/user/dataC-gantt-support').reply(200, getDataGanttSupport);
  mock.onGet('/getTableForm').reply(200, getTableForm);
  mock.onGet('/branch').reply(200, branchs);
  mock.onPost('/branch/select').reply(200, {});
}
